import { useState, useEffect } from "react";
import { API_URLS } from "./config";
// import { LanguageContext } from "../locale";
import { useLanguage } from "LanguageContext";
import axios from 'axios';
// import { hostname } from "os";

export interface Rule {
  title: string;
  subtitle: string;
  paragraph: string;
  before_url: string;
  url: string;
  slug: string;
  badge: string;
  position: number;
}

export interface ReferenceData {
  title: string;
  paragraph: string;
  rules: Rule[];
}

export function useReferenceService() {
  const lang = useLanguage();
  const [referenceData, setReferenceData] = useState<ReferenceData | null>(
    null
  );
  const [loading, setLoading] = useState<Boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const domain = window.location.hostname;

  useEffect(() => {
    const fetchReferenceData = async () => {
      try {
        const response = await axios.get(API_URLS.REFERENCES, {
              params: {
          filters: {
            frontend_types: {
              hostname: {
                $eq: domain,
              },
            },
          },
          populate: {
             rules_rules_sets: {
               populate: "*",
            },
            frontend_types: {
              populate: ['logo'], // populate only the logo field
            },
          },
          locale: lang.language,
          }
        });

        // check response
        if (response.status !== 200) {
          throw new Error("Failed to fetch Ruleset data");
        }

        const json = response.data;
        const data = {
          title: json?.data[0]?.title || "Cadres de Référence",
          paragraph: json?.data[0]?.paragraph || "Description indisponible",
          rules: json?.data[0]?.rules_rules_sets
            ? json?.data[0].rules_rules_sets?.sort((x:any, y:any) => x?.position - y?.position).map((rule: Rule) => ({
                title: rule?.title,
                subtitle: rule?.subtitle,
                paragraph: rule?.paragraph,
                before_url: rule?.before_url || "",
                url: rule?.url || "",
                slug: rule?.slug || "",
                badge: rule?.badge,
                position: rule?.position,

              }))
            : [],
        };
        setReferenceData(data);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchReferenceData();
  }, [lang.language]);

  const getRuleBySlug = (slug: string) => {
    return referenceData?.rules.find((rule) => rule.slug === slug);
  };

  const getMainTitle = () => {
    return referenceData?.title || "Cadres de Référence";
  };

  return { referenceData, loading, error, getRuleBySlug, getMainTitle };
}
